import { ContentfulAccordion, ContentfulAccordionEntry } from '@jbhi-fi/apis/src/contentful/types';
import { AccordionItems, AccordionProps } from '@jbhi-fi/lanyard-ui/components/Accordion';
import React from 'react';
import NegativeIcon from '@jbhi-fi/lanyard-ui/components/Icons/Negative';
import PositiveIcon from '@jbhi-fi/lanyard-ui/components/Icons/Positive';
import { RichText } from '../../RichText';

export abstract class AccordionTransformer {
  static toAccordionEntryProps = (entry: ContentfulAccordionEntry): AccordionItems => {
    const heading = entry?.fields?.heading;
    const body = entry?.fields?.mainBody;
    return {
      head: <span>{heading}</span>,
      content: body ? <RichText document={body} /> : null,
      closeIcon: <NegativeIcon />,
      openIcon: <PositiveIcon />,
      disabled: false,
    };
  };

  static toAccordionProps = (entry: ContentfulAccordion): AccordionProps => {
    return {
      id: entry?.sys?.id,
      items: entry?.fields?.accordionEntries.map(item => this.toAccordionEntryProps(item)) || [],
      multiOpen: false,
      defaultActiveIndex: null,
      isCollapsible: true,
    };
  };
}
